import React, { useEffect } from 'react';
import { Redirect} from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';


import { loadUser } from '../../actions/auth';

const Dashboard = ({ 
  auth: { user }, history, profile: {profile, loading}
}) => {

  useEffect(() => {
    loadUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadUser]);

  return (
    user && user.ltype === 'V' ? (
        <Redirect to='/verify' />        
      ) : (
        user && user.ltype === 'U' ? (
        <Redirect to='/update' /> ) : (
          user && user.ltype === 'A' ? (
            <Redirect to='/attend' /> ) : (
              user && user.ltype === 'C' ? (
              <Redirect to="/dload" /> ) : (
                user && user.ltype === 'Z' ? (
                  <Redirect to="/coord" /> ) : null
              )
              )
            )
        ) ) 
}

Dashboard.propTypes = {
  auth: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  auth: state.auth,
  profile: state.profile
});

export default connect(
  mapStateToProps,
  { }
)(Dashboard);
